import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    NavigationTableRequestModel,
    NavigationTableResponseItemModel,
    NavigationTableResponseModel
} from '../../models/file-table.model';
import {DocumentsServiceService} from '../../controllers/documents/documents-service.service';

@Component({
    selector: 'app-component-file-navigator',
    templateUrl: './file-navigator.component.html',
    styleUrls: ['./file-navigator.component.scss']
})
export class FileNavigatorComponent implements OnInit {
    /** тип навигатора: file, collection */
    @Input() public selectedType = 'file';

    /** множественный выбор */
    @Input() public isMultiple = false;

    /** Используется для определения использования в контракте для модернизации запроса */
    @Input() public isForContract = true;

    @Output() public eventSelected: EventEmitter<NavigationTableResponseItemModel[]> =
        new EventEmitter<NavigationTableResponseItemModel[]>();

    @Input() public selects: NavigationTableResponseItemModel[] = [];
    
    @Output() public eventSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    @Input() public maxHeight: string = '500px';
    isCreateCollection: boolean;
    isCreateFolder = true;
    isCollection = false;

    constructor(
        public controller: DocumentsServiceService,
    ) {
    }

    ngOnInit(): void {
        this.controller.$mediator = new EventEmitter<NavigationTableResponseModel>();
        this.onEventFind();

        this.controller.$mediator.subscribe(res => {
            this.isCreateFolder = res.right ? res.right.is_create_folder : true;
            if (res.folder) {
                this.isCreateCollection = res.right.is_upload_file;
            } else {
                this.isCreateCollection = false;
            }
        });
    }

    onEventFind(request: NavigationTableRequestModel = null): void {
        if (!request) {
            request = new NavigationTableRequestModel();
        }
        request.limit = 15;
        this.controller.loadNav(request);

        this.onEventTrSelected([]);
    }

    onEventTrClick(item: NavigationTableResponseItemModel): void {
        this.isCollection = item.type_str === 'collection';
        if (item && item.type_str === 'file') {
            return;
        }

        let filterStr = 'all';

        if (this.selectedType === 'file') {
            if (item && item.type_str === 'collection') {
                filterStr = item.type_str;
            }
        }

        if (this.selectedType === 'collection' && item.type_str === 'collection') {
            return;
        }

        if (item) {
            this.onEventFind(this.controller.prepare({
                id: item.id,
                filter: filterStr,
                has_contract: !this.isForContract
            }));
        }
    }

    onEventTrSelected(items: NavigationTableResponseItemModel[]): void {
        const push = (this.selects && this.isMultiple) ? this.selects : [];
        for (const item of items) {
            if (item.type_str === this.selectedType && !push.filter(x => x.key === item.key)[0]) {
                push.push(item);
            }
            this.selects = push;
            this.eventSelected.emit(this.selects);
        }
    }

    submitItem(): void {
        this.eventSubmit.emit();
    }

    removeSelectItem(item: NavigationTableResponseItemModel): void {
        this.selects = this.selects.filter(x => x.key ? (x.key !== item.key) : (x.id !== item.id));
        this.eventSelected.emit(this.selects);
    }
}
